import * as _ from 'gleam:prelude'
import { jwtDecode } from 'jwt-decode'

export function permissions(token) {
  try {
    const decoded = jwtDecode(token)
    return _.Result$Ok(decoded.permissions)
  } catch (error) {
    return _.Result$Error()
  }
}
